import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/components/layout/Layout";
import UnifiedLoginView from "@/views/UnifiedLoginView.vue";

import FloatView from "@/views/point-of-sale/floatCashup/FloatView";
import ViewInvoicesView from "@/views/point-of-sale/payment/ViewInvoicesView";
import SplitPaymentView from "@/views/point-of-sale/payment/SplitPaymentView";
import PaymentView from "@/views/point-of-sale/payment/PaymentView";
import CashupView from "@/views/point-of-sale/floatCashup/CashupView";
import LayByPayment from "@/views/point-of-sale/sale/LayByPayment";
import OtpView from "@/views/OtpView.vue";
import store from '@/store/index'
import { Storage } from "@/services/Storage";
import { getValue as getStorageValue } from "@/services/storageAdapter";
import { useAppUsage } from '@/composables/useAppUsage';

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: "poslogin",
        component: UnifiedLoginView,
    },
    {
        path: '/OTP',
        name: "OtpView",
        component: OtpView,
    },
    {
        path: '/customer-display',
        name: "customer-display",
        component: () => import('@/views/customer/CustomerDisplayView.vue'),
    },
    {
        path: '/validation',
        name: 'validation',
        component: () => import(/* webpackChunkName: "validation" */ '../views/ValidationView.vue')
    },
    {
        path: '/select-subscription-type',
        name: "select-subscription-type",
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "select-subscription-type" */ '../views/setup/SelectSubscriptionType')
    },
    {

        path: '/',
        component: Layout,
        children: [
            {
                path: '/pos',
                name: 'pos',
                component: () => import(/* webpackChunkName: "pos-view" */ '@/views/point-of-sale/POSView'),
            },
            {
                path: '/view-sale',
                name: "viewSale",
                component: () => import(/* webpackChunkName: "ViewSale" */'../views/point-of-sale/sale/ViewSaleView'),
            },
            {
                path: '/stock-take',
                name: "stock-take",
                component: () => import(/* webpackChunkName: "stock-take" */ '../views/boffice/StockTake/StockTakeListView'),
            },
            {
                path: '/run-stock-take',
                name: "run-stock-take",
                component: () => import(/* webpackChunkName: "run-stock-take" */ '../views/boffice/StockTake/StockTakeItemsView'),
            },
            {
                path: '/stock-transfer',
                name: "stock-transfer",
                component: () => import(/* webpackChunkName: "stock-transfer" */ '../views/boffice/stock-transfer/SelectTransferTypeView'),
            },
            {
                path: '/select-receiving-store',
                name: "select-receiving-store",
                component: () => import(/* webpackChunkName: "select-receiving-store" */ '../views/boffice/stock-transfer/SelectReceivingStoreView'),
            },
            {
                path: '/search-items-to-send',
                name: "search-items-to-send",
                component: () => import(/* webpackChunkName: "search-items-to-send" */ '../views/boffice/stock-transfer/SearchItemsToSendView'),
            },
            {
                path: '/view-items-to-send',
                name: "view-items-to-send",
                component: () => import(/* webpackChunkName: "view-items-to-send" */ '../views/boffice/stock-transfer/ViewItemsToSendView'),
            },
            {
                path: '/incoming-stock-transfer',
                name: 'incoming-stock-transfer',
                component: () => import(/* webpackChunkName: "stock-transfer-incoming" */ '../views/boffice/stock-transfer/IncomingTransfersView'),
            },
            {
                path: '/view-incoming-transfer',
                name: 'view-incoming-transfer',
                component: () => import(/* webpackChunkName: "stock-transfer-view" */ '../views/boffice/stock-transfer/ViewIncomingTransferView'),
            },
            {
                path: '/saved-stock-transfer',
                name: 'saved-stock-transfer',
                component: () => import(/* webpackChunkName: "stock-transfer-saved" */ '../views/boffice/stock-transfer/SavedTransfersView'),
            },
            {
                path: '/not-received-transfer',
                name: 'not-received-transfer',
                component: () => import(/* webpackChunkName: "stock-transfer-not-received" */ '../views/boffice/stock-transfer/NotReceivedTransfersView'),
            },
            {
                path: '/rejected-stock-transfer',
                name: 'rejected-stock-transfer',
                component: () => import(/* webpackChunkName: "stock-transfer-rejected" */ '../views/boffice/stock-transfer/RejectedTransfersView'),
            },
            {
                path: '/StockRecords',
                name: "StockRecords",
                component: () => import(/* webpackChunkName: "stock-take" */ '../views/boffice/StockTake/StockRecords'),
            },

            {
                path: '/payment',
                name: "payment",
                component: PaymentView
            },
            {
                path: '/lay-by-payment',
                name: "lay-by-payment",
                component: LayByPayment
            },

            {
                path: '/split-payment',
                name: "split-payment",
                component: SplitPaymentView
            },
            {
                path: '/view-payment',
                name: "viewPayment",
                component: ViewInvoicesView
            },
            {
                path: '/offline-invoices',
                name: "offline-invoices",
                component: () => import(/* webpackChunkName: "offline-invoices" */ '../views/point-of-sale/payment/OfflineInvoicesView')
            },
            {
                path: '/online-orders',
                name: 'online-orders',
                component: () => import(/* webpackChunkName: "online-orders" */ '../views/orders/OnlineOrdersView.vue')
            },
            {
                path: '/float',
                name: "float",
                component: FloatView,
            },
            {
                path: '/instruction',
                props: true,
                name: "instruction",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "instruction" */ '../views/point-of-sale/cookingInstruction/CookingInstruction'),
            },
            {
                path: '/cashup',
                name: "cashup",
                component: CashupView,
            },

            {
                path: '/cashup-records',
                name: "cashup-records",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "cashup-records" */ '../views/point-of-sale/floatCashup/CashupRecordsView.vue'),
            },

            {
                path: '/sales-records',
                name: "salesRecords",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "salesRecords" */ '../views/point-of-sale/SalesRecordsView'),
            },
            {
                path: '/lay-by-sales',
                name: "lay-by-sales",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "lay-by-sales" */ '../views/point-of-sale/LayBy/LayBySales'),
            },
            {
                path: '/TicketRequest',
                name: "TicketRequest",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "salesRecords" */ '../views/point-of-sale/TicketRequest.vue'),
            },
            {
                path: '/CreateTicket',
                name: 'CreateTicket',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "SystemAdjustments" */ '../views/point-of-sale/tables/CreateTicket'),
            },
            {
                path: '/ViewOpenTicket',
                name: 'ViewOpenTicket',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "SystemAdjustments" */ '../views/point-of-sale/ViewOpenTicket.vue'),
            },
            {
                path: '/ViewClosedTicket',
                name: 'ViewClosedTicket',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "ViewClosedTicket" */ '../views/point-of-sale/ViewClosedTicket.vue'),
            },
            {
                path: '/ticket/:id',
                name: 'TicketDetail',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "TicketDetail" */ '../views/point-of-sale/TicketDetails.vue'),
                // component: TicketDetail,
            },
            {
                path: '/settings',
                name: "settings",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "settings" */ '../views/boffice/settings/SettingsView'),
            },

            {
                path: '/view-invoice/:invoice',
                name: "viewInvoice",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "viewInvoice" */ '../views/point-of-sale/InvoiceDetailsView'),
            },
            {
                path: '/loyalty-customers',
                name: "loyalty-customers",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "loyalty-customers" */ '../views/point-of-sale/Loyalty/LoyaltyCustomers'),
            },

            {
                path: '/refund-invoice/:invoice',
                name: "refundInvoice",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "refundInvoice" */ '../views/point-of-sale/RefundInvoiceView'),
            },

            {
                path: '/tables',
                name: "tables",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "tables" */ '../views/point-of-sale/tables/AllTablesView'),
            },

            {
                path: '/CreateVoucher',
                name: "CreateVoucher",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "create-table" */ '../views/point-of-sale/Voucher/CreateVoucher'),
            },
            {
                path: '/create-table',
                name: "create-table",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "create-table" */ '../views/point-of-sale/tables/CreateTableView'),
            },

            {
                path: '/select-customer',
                name: "select-customer",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "select-customer" */ '../views/point-of-sale/Accounts/SelectCustomerView'),
            },

            {
                path: '/create-debtor',
                name: "create-debtor",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "create-debtor" */ '../views/point-of-sale/Accounts/CreateDebtorView'),
            },

            {
                path: '/subscription-accounts',
                name: 'subscription-accounts',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "subscription-accounts" */ '../views/setup/Expired/SubscriptionsAndAccountsView'),
            },
            {
                path: '/merge-tables',
                name: 'merge-tables',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "merge-tables" */ '../views/point-of-sale/tables/MergeTables'),
            },
            {
                path: '/split-table',
                name: 'split-table',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "split-table" */ '../views/point-of-sale/tables/SplitTableView'),
            },
            {
                path: '/help',
                name: 'help',
                component: () => import(/* webpackChunkName: "help" */ '../views/Help/HelpView.vue'),
            },
            {
                // In-app update flow. See docs/exec-plans/active/2026-06-23-app-update-flow.md.
                path: '/updates',
                name: 'updates',
                component: () => import(/* webpackChunkName: "updates-view" */ '../views/UpdatesView.vue'),
            },

        ]
    },

    {
        path: '/email-settings',
        name: "email-settings",
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "email-settings" */ '../views/boffice/settings/EmailSetupView'),
    },

    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "login"*/ '../views/LoginView.vue'),
    },
    {
        path: '/setup',
        name: 'setup',
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "setup"*/ '../views/setup/AppSetupLogin.vue')
    },
    {
        path: '/SelectUserView',
        name: 'SelectUserView',
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "setup"*/ '../views/SelectUserView.vue')
    },

    {
        path: '/system-expired',
        name: 'system-expired',
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "system-expired"*/ '../views/setup/Expired/SystemExpired')
    },

    {
        path: '/make-subscription-payment',
        name: 'make-subscription-payment',
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "make-subscription-payment"*/ '../views/setup/Expired/MonthlyPaymentView')
    },

    {
        path: '/expire-extension',
        name: 'expire-extension',
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "expire-extension"*/ '../views/setup/Expired/ExtensionSuccess')
    },
    {
        path: '/ticket',
        name: 'ticket',
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "expire-extension"*/ '../views/boffice/StockTake/Ticket.vue')
    },

    {
        path: '*',
        name: "notfound",
        component: UnifiedLoginView
    },

]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})
window.popStateDetected = false
window.addEventListener('popstate', () => {
    window.popStateDetected = true
})

// Handle NavigationDuplicated errors silently
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
    })
}

// Also handle replace method to prevent NavigationDuplicated errors
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
    })
}

router.beforeEach(async (to, from, next) => {
    // App Usage Tracking: Record page views (only for authenticated users)
    // Use queueEvent for batching - reduces API calls significantly
    try {
        const { setUser, queueEvent } = useAppUsage()

        // Get current user from store (Vuex module)
        const currentUser = store.getters.getCurrentUser
        const isAuthenticated = currentUser && (currentUser.UserID || currentUser.id) &&
            currentUser.Username && String(currentUser.Username).trim().length > 0

        // Only track page views for authenticated users (after hydration)
        if (store.getters.isHydrated && isAuthenticated) {
            const userId = currentUser.UserID || currentUser.id
            setUser(userId)

            // Queue event for batch processing (not immediate API call)
            if (to.name) {
                queueEvent('page:' + to.name, 'view')
            }
        }
    } catch (e) {
        // Silently ignore tracking errors - should not affect navigation
    }

    if (!store.getters.isHydrated) {
        await new Promise((resolve) => {
            const interval = setInterval(() => {
                if (store.getters.isHydrated) {
                    clearInterval(interval);
                    resolve();
                }
            }, 50);  // Check every 50ms
        });
    }

    // Always allow core pre-login routes
    const preloginWhitelist = ['validation', 'make-subscription-payment', 'system-expired', 'setup', 'login', 'poslogin', 'customer-display'];
    if (preloginWhitelist.includes(to.name)) {
        return next();
    }

    let exceptions = routeExceptions;
    if (exceptions.includes(to.name)) {
        next();
    } else {
        if (!exceptions.includes(to.name)) {

            let res = await auth.isAdminLoggedIn()
            let storeDB = !!(await Storage.getCurrentStoreDB());
            let currentUser = store.getters.getCurrentUser;
            let userauth = !!(currentUser && currentUser.Username && String(currentUser.Username).trim().length > 0);

            // Recover admin session from persisted storage on refresh (e.g. Android WebView reload)
            if (!res) {
                const adminUser = await Storage.getAdminUser();
                if (adminUser) {
                    res = true;
                }
            }

            // Recover store selection from SQLite only — do not call
            // Storage.getDefaultStore() here; it can re-bind from hardware
            // after a store-only sign-out cleared default_store.
            if (!storeDB) {
                try {
                    const defaultStore = await getStorageValue('default_store');
                    if (defaultStore && defaultStore.StoreDB) {
                        store.commit('setDefaultStore', defaultStore);
                        storeDB = true;
                    }
                } catch (_) {
                    /* ignore */
                }
            }

            // Recover POS user session from persisted storage before forcing a route-level logout.
            if (!userauth && storeDB) {
                const persistedUser = await Storage.getCurrentUser();
                const hasPersistedUser = !!(persistedUser && persistedUser.Username && String(persistedUser.Username).trim().length > 0);
                if (hasPersistedUser) {
                    store.commit('setCurrentUser', persistedUser);
                    currentUser = persistedUser;
                    userauth = true;
                }
            }

            if (res && !userauth && storeDB && to.name !== 'poslogin' && to.name !== 'validation' && to.name !== 'setup' && to.name !== 'system-expired' && to.name !== 'make-subscription-payment') {
                next({ name: 'poslogin', replace: true })
            } else if (!res && !storeDB) {
                if (to.name === 'poslogin') return next();
                next({ name: 'poslogin', replace: true })  // Changed from 'login' to 'poslogin'
            } else {
                next()
            }
        } else {
            next()
        }
    }
})


export default router
